// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const preloadAssets = (_: string[]): void => {
  // We don't need to preload web assets as this is done by the downloader
};
